// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';
import {
    Dropdown,
    Button,
    Icon,
    Modal,
    ToggleButton,
    Loader,
} from '../../common';
import { PreviewItems } from '../';
import ImportProducts from '../../products/importProducts/ImportProducts';
import styles from './PreviewTransfers.scss';

class PreviewTransfers extends Component {
    state = {
        warehouse_from: '',
        warehouse_to: '',
        modalOpen: false,
        importError: '',
        importSuccess: '',
        lines: [],
        newVersion: false,
    };

    componentDidMount = () => {
        if (this.props.initialLines && !this.props.isInitialLoading) {
            const { lines } = this.state;
            const newLines = lines.concat(this.props.initialLines);
            this.setState({
                lines: newLines,
            });
            if (this.props.asnInfo && this.props.asnInfo.id_fbn_asn) {
                this.getFbnBatches(this.props.asnInfo.id_fbn_asn);
            }
        }
        if (this.props.asnInfo === 'closed') {
            this.props.history.push(`/${Helper.getLocale()}/transfers`);
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        // if (!this.props.isInitialLoading) {
        // if (this.props.isInitialLoaded !== prevProps.isInitialLoaded) {
        //   const lines = this.props.initialLines;
        //
        //   this.setState({
        //     lines,
        //     notNew: false
        //   });
        // } else {
        if (!_.isEqual(this.props.initialLines, prevProps.initialLines)) {
            const { lines } = this.state;
            let newLines = this.props.initialLines;
            if (
                this.props.asnInfo.type === prevProps.asnInfo.type &&
                this.props.initialLines &&
                prevProps.initialLines &&
                !_.isEmpty(this.props.initialLines) &&
                !_.isEmpty(prevProps.initialLines) &&
                this.props.initialLines[0].id_fbn_asn_batch ===
                    prevProps.initialLines[0].id_fbn_asn_batch
            ) {
                let ev = false;
                for (let j = 0; j < lines.length; j++) {
                    if (
                        lines[j].id_fbn_asn_batch !==
                        this.props.initialLines[0].id_fbn_asn_batch
                    ) {
                        ev = true;
                        break;
                    }
                }
                if (!ev) {
                    newLines = lines.concat(this.props.initialLines);
                }
            }

            this.setState({
                lines: newLines,
            });
        }
        if (
            this.props.asnInfo &&
            this.props.asnInfo !== prevProps.asnInfo &&
            this.props.asnInfo.id_fbn_asn
        ) {
            this.getFbnBatches(this.props.asnInfo.id_fbn_asn);
        }
        if (
            this.props.batches &&
            !this.props.importedBatch &&
            !_.isEmpty(this.props.batches) &&
            !_.isEqual(this.props.batches, prevProps.batches)
        ) {
            this.props.toggleBatch(this.props.batches[0].id_fbn_asn_batch);
        }
        if (
            !this.props.currentBatch &&
            !this.props.importedBatch &&
            this.props.initialLines &&
            !_.isEmpty(this.props.initialLines) &&
            this.props.initialLines[0].id_fbn_asn_batch
        ) {
            this.props.toggleBatch(this.props.initialLines[0].id_fbn_asn_batch);
        }
        if (
            this.props.importedBatch &&
            this.props.importedBatch !== prevProps.importedBatch &&
            this.props.lineType === 1
        ) {
            this.props.toggleBatch(this.props.importedBatch);
        }
    };

    getFbnBatches = id_fbn_asn => {
        this.props.getAsnBatches(id_fbn_asn);
    };

    openModal = newVersion => {
        this.setState({
            modalOpen: true,
            newVersion: newVersion,
        });
    };

    onCloseModal = () => {
        this.setState({
            modalOpen: false,
            importError: '',
            importSuccess: '',
        });
    };

    importOffers = file => {
        if (file) {
            this.props.importFbnAsn(file);
            this.onCloseModal();
        }
    };
    render() {
        const {
            data,
            isImporting,
            isScheduleLoading,
            asnInfo,
            history,
            browser,
            loadFunc,
            scheduleAsn,
            isInitialLoading,
            exportEligibleOffers,
            isExporting,
            toggleLines,
            lineType,
            typeChanged,
            batches,
            toggleBatch,
            currentBatch,
            scrollPage,
            noOfPages,
            printCall,
            isPrintLoading,
            setRef,
            exportAsn,
            isExportLoading,
            retrieveSlots,
            slots,
            seller,
            isGettingSlots,
            barcodeRecvMethod,
        } = this.props;
        let businessItems = [
            I18n.getText('transfers.planned'),
            I18n.getText('transfers.scheduled'),
        ];

        const batchesList =
            batches && !_.isEmpty(batches)
                ? batches.map((batch, index) => (
                      <div
                          className={`${styles.eachBatch} ${
                              currentBatch === batch.id_fbn_asn_batch
                                  ? styles.selected
                                  : ''
                          }`}
                          onClick={() => toggleBatch(batch.id_fbn_asn_batch)}
                      >
                          <div className={styles.name}>{`${batch.name}`}</div>
                          <div>
                              {batch.is_scheduled ? (
                                  <Icon name="checkmark" />
                              ) : (
                                  ''
                              )}
                              <div className={styles.count}>{batch.count}</div>
                          </div>
                      </div>
                  ))
                : '';

        const slotList =
            asnInfo && asnInfo.slot && !_.isEmpty(asnInfo.slot)
                ? asnInfo.slot.map((eachSlot, index) => (
                      <span>
                          {eachSlot}
                          {index + 1 < asnInfo.slot.length ? ', ' : ''}
                      </span>
                  ))
                : '';

        const emptyBatch =
            batches &&
            !_.isEmpty(batches) &&
            batches[batches.length - 1] &&
            !batches[batches.length - 1].count;

        return (
            <div className={styles.ctr}>
                <div className={styles.header}>
                    <div className={styles.titleCtr}>
                        <h6 className={styles.sub}>
                            {I18n.getText('transfers.asn-id')}
                        </h6>
                        <h6 className={styles.main}>{asnInfo.asn_nr}</h6>
                    </div>
                    {barcodeRecvMethod && (
                        <div className={styles.titleCtr}>
                            <h6 className={styles.sub}>
                                {I18n.getText('transfers.recv-type')}
                            </h6>
                            <h6 className={styles.main}>
                                {I18n.getText('transfers.barcode')}
                            </h6>
                        </div>
                    )}
                    <div className={styles.titleCtr}>
                        <h6 className={styles.sub}>
                            {I18n.getText('transfers.from-wh')}
                        </h6>
                        <h6 className={styles.main}>
                            {asnInfo.warehouse_from}
                        </h6>
                    </div>
                    <div className={styles.titleCtr}>
                        <h6 className={styles.sub}>
                            {I18n.getText('transfers.to-wh')}
                        </h6>
                        <h6 className={styles.main}>{asnInfo.warehouse_to}</h6>
                    </div>
                    {asnInfo.scheduled_at ? (
                        <div className={styles.titleCtr}>
                            <h6 className={styles.sub}>
                                {I18n.getText('transfers.scheduled-at')}
                            </h6>
                            <h6 className={styles.main}>
                                {asnInfo.scheduled_at}
                            </h6>
                            <h6 className={styles.main}>{slotList}</h6>
                            {seller && seller.is_fbn_asn_priority ? (
                                <div className={styles.blinkMe}>
                                    {I18n.getText('transfers.priority')}
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={styles.importBtnCtr}>
                        <div className={styles.importTxt}>
                            {I18n.getText('transfers.export-eligible-text')}
                        </div>
                        <Button
                            variant="secondary"
                            className={`${styles.printCtr}`}
                            onClick={() => exportEligibleOffers()}
                        >
                            <Icon
                                name="download"
                                className={styles.printIcon}
                            />
                            {isExporting ? (
                                <div className={styles.loader} />
                            ) : (
                                I18n.getText('transfers.export-eligible-offers')
                            )}
                        </Button>
                    </div>
                </div>
                <ToggleButton
                    toggleBtn={toggleLines}
                    toggleItems={businessItems}
                    selected={lineType}
                    tab
                    btns={
                        lineType === 2 &&
                        asnInfo &&
                        asnInfo.status !== 'cancelled' &&
                        this.state.lines &&
                        !_.isEmpty(this.state.lines) && (
                            <div className={styles.btnCtr}>
                                <Button
                                    variant="transparent"
                                    className={`${styles.printCtr} ${
                                        styles.tabBtn
                                    }`}
                                    onClick={() =>
                                        exportAsn(
                                            asnInfo && asnInfo.asn_nr,
                                            null,
                                            'fbn',
                                            asnInfo && asnInfo.status,
                                        )
                                    }
                                >
                                    <Icon
                                        name="download"
                                        className={styles.printIcon}
                                    />
                                    {isExportLoading ? (
                                        <div className={styles.loader} />
                                    ) : (
                                        I18n.getText('statement.export-asn')
                                    )}
                                </Button>
                                <Button
                                    variant="primary"
                                    className={`${styles.printCtr} ${
                                        styles.tabBtn
                                    }`}
                                    onClick={() =>
                                        printCall(
                                            asnInfo && asnInfo.asn_nr,
                                            null,
                                            'fbn',
                                            asnInfo && asnInfo.status,
                                        )
                                    }
                                >
                                    <Icon
                                        name="print"
                                        className={styles.printIcon}
                                    />
                                    {isPrintLoading ? (
                                        <div className={styles.loader} />
                                    ) : (
                                        I18n.getText('statement.tooltip-print')
                                    )}
                                </Button>
                            </div>
                        )
                    }
                />
                {isInitialLoading && typeChanged ? (
                    <Loader />
                ) : this.state.lines ? (
                    <div className={styles.flexView}>
                        {lineType === 1 && batches && !_.isEmpty(batches) ? (
                            <div className={styles.side}>
                                {batchesList}
                                {emptyBatch ||
                                (asnInfo && asnInfo.status === 'cancelled') ? (
                                    ''
                                ) : (
                                    <Button
                                        className={`${styles.printCtr} ${
                                            styles.batchBtn
                                        }`}
                                        onClick={() => this.openModal('new')}
                                        variant="transparent"
                                    >
                                        <Icon
                                            name="plus"
                                            className={styles.printIcon}
                                        />
                                        {isImporting &&
                                        this.state.newVersion ? (
                                            <div className={styles.loader} />
                                        ) : (
                                            I18n.getText('transfers.add-batch')
                                        )}
                                    </Button>
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                        <PreviewItems
                            lines={this.state.lines}
                            history={history}
                            browser={browser}
                            isImporting={isImporting}
                            loadFunc={loadFunc}
                            scheduleAsn={scheduleAsn}
                            type={lineType}
                            batches={batches}
                            toggleBatch={toggleBatch}
                            currentBatch={currentBatch}
                            asnInfo={asnInfo}
                            fbnAsn={asnInfo && asnInfo.id_fbn_asn}
                            openModal={this.openModal}
                            scrollPage={scrollPage}
                            noOfPages={noOfPages}
                            retrieveSlots={retrieveSlots}
                            isInitialLoading={isInitialLoading}
                            slots={slots}
                            isGettingSlots={isGettingSlots}
                            barcodeRecvMethod={barcodeRecvMethod}
                        />
                    </div>
                ) : (
                    <div className={styles.blankBtn}>
                        <div className={styles.importTxt}>
                            {I18n.getText('transfers.import-fbn-transfers')}
                        </div>
                        <Button
                            className={styles.printCtr}
                            onClick={() => this.openModal()}
                        >
                            <Icon name="stack" className={styles.printIcon} />
                            {isImporting ? (
                                <div className={styles.loader} />
                            ) : (
                                I18n.getText('transfers.import-offers')
                            )}
                        </Button>
                    </div>
                )}
                <Modal
                    contentLabel={'ProductImport'}
                    isOpen={this.state.modalOpen}
                    closeModal={() => this.onCloseModal()}
                >
                    <ImportProducts
                        importOffers={this.importOffers}
                        isLoading={this.props.isImporting}
                        closeModal={() => this.onCloseModal()}
                        idFbnAsnBatch={
                            !this.state.newVersion &&
                            this.state.lines &&
                            _.isEmpty(this.state.lines) &&
                            currentBatch
                        }
                        fbnAsn={asnInfo && asnInfo.id_fbn_asn}
                        success={
                            this.props.isImportCompleted && this.props.success
                                ? this.props.success
                                : ''
                        }
                        error={this.state.importError}
                        success={this.state.importSuccess}
                    />
                </Modal>
            </div>
        );
    }
}
export default PreviewTransfers;



// WEBPACK FOOTER //
// ./src/components/transfers/previewTransfers/PreviewTransfers.js